export const signUpUrl = 'https://signup.vouchedfor.co.uk/'
export const elevationSignUpUrl = 'https://professionals.vouchedfor.co.uk/elevation'

export const ELEVATION_FIRM_PERFORMANCE_PATH = "/_auth/elevation/firm-performance"
export const ELEVATION_FIRM_PERFORMANCE_URL = "/elevation/firm-performance"

export const ELEVATION_BY_ADVISER_PATH = '/_auth/elevation/professionals/elevation-performance'
export const ELEVATION_BY_ADVISER_URL = '/elevation/professionals/elevation-performance'

export const ELEVATION_PERFORMANCE_FIRM_PATH = "/_auth/performance-firm"
export const ELEVATION_PERFORMANCE_FIRM_URL = "/performance-firm"

export const ELEVATION_PERFORMANCE_OVER_TIME_PATH = "/_auth/performance-over-time"
export const ELEVATION_PERFORMANCE_OVER_TIME_URL = "/performance-over-time"
export const ELEVATION_ADVISER_PERFORMANCE_OVER_TIME_PATH = '/_auth/performance-adviser-over-time'
export const ELEVATION_ADVISER_PERFORMANCE_OVER_TIME_URL = '/performance-adviser-over-time'
export const ELEVATION_FIRM_PERFORMANCE_OVER_TIME_PATH = '/_auth/performance-firm-over-time'
export const ELEVATION_FIRM_PERFORMANCE_OVER_TIME_URL = '/performance-firm-over-time'

export const REVIEWS_PATH = '/_auth/reviews/'
export const REVIEWS_URL = '/reviews/'

export const REVIEW_PATH = '/_auth/reviews/review/$id'
export const FIRST_IMPRESSION_PATH = '/_auth/reviews/first-impression/$id'

export const ADVISERS_PATH = '/_auth/advisers/'
export const ADVISERS_URL = '/advisers/'

export const PROFESSIONALS_PATH = '/_auth/professionals/'
export const PROFESSIONALS_URL = '/professionals/'

export const VERIFIED_ADVISER_SCORES_PATH = '/_auth/verified-adviser-scores'
export const VERIFIED_ADVISER_SCORES_URL = '/verified-adviser-scores'

export const NETWORK_FIRMS_PERFORMANCE_PATH = "/_auth/network/firms-performance"
export const NETWORK_FIRMS_PERFORMANCE_URL = "/network/firms-performance"

export const PERFORMANCE_BY_ADVISER_PATH = '/_auth/professionals/performance'
export const PERFORMANCE_BY_ADVISER_URL = '/professionals/performance'

export const RISK_AND_OPPORTUNITY_SETTINGS_PATH = '/_auth/risk-and-opportunity-settings'
export const RISK_AND_OPPORTUNITY_SETTINGS_URL = '/risk-and-opportunity-settings'

export const TOP_RATED_ADVISERS_PATH = '/_auth/top-rated-adviser/'
export const TOP_RATED_ADVISERS_URL = '/top-rated-adviser/'

export const RISK_REPORT_PATH = '/_auth/report/risk'
export const RISK_REPORT_URL = '/report/risk'

export const OPPORTUNITY_REPORT_PATH = "/_auth/report/opportunity"
export const OPPORTUNITY_REPORT_URL = '/report/opportunity'

export const PROFILE_PATH = "/_auth/profile/"
export const PROFILE_URL = "/profile/"

export const TOOLS_FIRM_PATH = '/_auth/tools/'
export const TOOLS_FIRM_URL = '/tools/'

export const ELEVATION_PERFORMANCE_ADVISER_PATH = "/_auth/performance-adviser"
export const ELEVATION_PERFORMANCE_ADVISER_URL = "/performance-adviser"

export const ADVISER_REPUTATIONAL_TOOLS_PATH = '/_auth/adviser-reputational-tools'
export const ADVISER_REPUTATIONAL_TOOLS_URL = '/adviser-reputational-tools'

export const INVITE_HISTORY_PATH = '/_auth/invite-history'
export const INVITE_HISTORY_URL = '/invite-history'

export const REVIEW_INVITE_REQUESTS_PATH = '/_auth/invite-requests'
export const REVIEW_INVITE_REQUESTS_URL = '/invite-requests'

export const RISK_SETTINGS_API_URL = '/firm/risk-settings'
export const OPPORTUNITY_SETTINGS_API_URL = '/firm/opportunity-settings'
export const TOP_RATED_STATUS_URL = '/top-rated-status'
export const TOP_RATED_STATUS_PATH = '/_auth/top-rated-status/'
export const TOP_RATED_STATUS_COMPARE_FIRMS_URL = '/top-rated-status/compare-firms'
export const TOP_RATED_STATUS_COMPARE_FIRMS_PATH = '/_auth/top-rated-status/compare-firms/'
export const BULK_INVITE_CREATE_URL = "/bulk-invite/"
export const BULK_INVITE_CREATE_PATH = "/_auth/bulk-invite/"
export const BULK_INVITE_EDIT_URL = "/bulk-invite/$id"
export const BULK_INVITE_EDIT_PATH = "/_auth/bulk-invite/$id"
export const BULK_INVITE_API_URL = "/firm/bulk-invites"
export const BULK_INVITE_RECORDS_API_URL = "/firm/bulk-invite-records"

export const TOOLS_HELPDOC = "https://support.vouchedfor.co.uk/en/categories/749954-reputation-tools"

export const REPORTING_PATH = "/_auth/reporting"
export const REPORTING_URL = "/reporting"

export const ENQUIRIES_PATH = "/_auth/enquiries/"
export const ENQUIRIES_URL = "/enquiries/"

export const ENQUIRY_URL = "/enquiries/$id"
export const ENQUIRY_PATH = "/_auth/enquiries/$id"

export const ENQUIRY_REPORT_URL = "/enquiries/report/$id"
export const ENQUIRY_REPORT_PATH = "/_auth/enquiries/report/$id"

export const REVIEW_SETTINGS_PATH = '/_auth/review-settings'
export const REVIEW_SETTINGS_URL = '/review-settings'

export const FREE_TEXT_ANALYSIS_PATH = '/_auth/free-text-analysis'
export const FREE_TEXT_ANALYSIS_URL = '/free-text-analysis'

export const ARTICLES_PATH = '/_auth/articles/'
export const ARTICLES_URL = '/articles'
export const ARTICLES_API_URL = '/firm/articles'
export const ARTICLE_TAGS_API_URL = '/firm/articles/tags'

export const ARTICLE_EDIT_URL = '/articles/$articleId'
export const ARTICLE_EDIT_PATH = '/_auth/articles/$articleId'